export var MAX_CONTEXT_LENGTH = 500;
export var CANCEL_ACTIONS = {
  CANCEL: 'cancel',
  WITHDRAW: 'withdraw'
};
export var OTHER_CANCELLATION_REASONS = {
  label: 'Other',
  value: 18
};